import './shared/polyfills';

//todo: remove on production
//import 'beautiful-react-redux/check';

import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from "react-redux";
import * as serviceWorker from './serviceWorker';
import App from './scenes/layout';
import configureStore from "./store/configureStore";
import './index.css';
import rootReducer, {IApplicationState} from "./store";
import {Store} from "redux";
import {IHandshake} from "./store/common/types";
import {gameInit} from "./store/common/actions";
import getGlobalErrorHandler from "./shared/utils/getGlobalErrorHandler";
import handshake from "./store/common/handshake";
import { IStoreSdk } from './sdk/types';
import { setSdk } from './sdk';

type RequestIdleCallbackHandle = any;
type RequestIdleCallbackOptions = {
    timeout: number;
};
type RequestIdleCallbackDeadline = {
    readonly didTimeout: boolean;
    timeRemaining: (() => number);
};
type EventListener = (args: any) => void;

declare global {
    interface Window {
        sessionId: string;
        metrics: Record<string, { start: number; end: number; }>;
        requestIdleCallback: ((callback: ((deadline: RequestIdleCallbackDeadline) => void), opts?: RequestIdleCallbackOptions,) => RequestIdleCallbackHandle);
        game: {
            start: (sdk: IStoreSdk, payload: IHandshake) => Promise<void>;
            on: (eventName: string, listener: EventListener) => void;
            off: (eventName: string, listener: EventListener) => void;
        };
        FBInstant: any;

        DISABLE_SYNCHRONIZATION: boolean;
        DISABLE_ERROR_LOGGING: boolean;
        DISABLE_PERFORMANCE_TRACKING: boolean;
        DISABLE_PRODUCT_STORE: boolean;
        INITIAL_STATE: Partial<IApplicationState>;
        OVERRIDE_STATE: Partial<IApplicationState>;
    }
}

let store: Store<IApplicationState>;
const root = document.getElementById('root');
const eventListeners: Record<string, EventListener[]> = {};

export function getStore() {
    return store;
}

export function triggerEvent(eventName: string, args: any) {
    if (!eventListeners[eventName]) {
        return;
    }

    for (const eventListener of eventListeners[eventName]) {
        eventListener(args);
    }
}

window.game = {
    start: async (sdk: IStoreSdk, payload: IHandshake) => {
        setSdk(sdk);

        const state = await handshake(root, payload);

        sdk.updateSettings(state.settings?.sdk ?? {});

        window.onerror = getGlobalErrorHandler("GlobalError", payload, state);

        store = configureStore(state);

        store.dispatch(gameInit(payload.entryPoint));

        ReactDOM.render(
            (
                <Provider store={store}>
                    <App/>
                </Provider>
            ), root, () => {
                let event;
                if (typeof(CustomEvent) === 'function') {
                    event = new CustomEvent('init');
                } else {
                    event = document.createEvent('Event');
                    event.initEvent('init', true, true);
                }

                window.dispatchEvent(event);
            });
    },

    on: (eventName: string, listener: EventListener) => {
        if (!eventListeners[eventName]) {
            eventListeners[eventName] = [];
        }

        eventListeners[eventName].push(listener);
    },

    off: (eventName: string, listener: EventListener) => {
        if (!eventListeners[eventName]) {
            return;
        }

        const index = eventListeners[eventName].indexOf(listener);
        if (index > -1) {
            eventListeners[eventName].splice(index, 1);
        }
    }
};

const hot = (module as any).hot;
if (hot) {
    hot.accept('./', () => {
        store.replaceReducer(rootReducer);
    });

    hot.accept('./scenes/layout', () => {
        const NextApp = require('./scenes/layout').default;

        ReactDOM.render(
                <Provider store={store}>
                    <NextApp />
                </Provider>
            , root
        );
    });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
